import { tns } from 'tiny-slider';

export default async function init() {
  const imageSlider = document.querySelectorAll('.slider:not([data-initialized])');

  if (imageSlider.length) {
    imageSlider.forEach((element) => {
      const slideShow = element;
      slideShow.dataset.initialized = true;

      const slider = tns({
        container: slideShow.querySelector('.slider__slides'),
        autoWidth: true,
        nav: false,
        center: true,
        autoplay: false,
        prevButton: slideShow.querySelector('.slider__prev'),
        nextButton: slideShow.querySelector('.slider__next'),
        loop: false,
        edgePadding: 10,
        rewind: true,
        mouseDrag: true,
        gutter: 10,
        responsive: {
          1280: {
            gutter: 50
          },
          1024: {
            gutter: 30
          },
          768: {
            items: 20
          }
        }
      });

      slider.events.on('indexChanged', (info) => {
        // Finde das aktuell aktive Element mit aria-hidden="false"
        const prevCaption = slideShow.querySelector('.slider__caption[aria-hidden="false"]');
        if (prevCaption) {
          prevCaption.setAttribute('aria-hidden', 'true');
          // Optional: Aus Tab-Reihenfolge entfernen
          prevCaption.setAttribute('tabindex', '-1');
        }

        // Finde das neue aktive Element
        const nextCaption = slideShow.querySelector(`.slider__caption[data-slide="${info.index + 1}"]`);
        if (nextCaption) {
          nextCaption.setAttribute('aria-hidden', 'false');
          // Optional: Fokussierbar machen
          nextCaption.removeAttribute('tabindex');
        }
      });
    });
  }
}
